import Vue from 'vue';

Vue.config.devtools = true
const mutations = {
    setCuratedBox(state, payload) {
        state.curatedBox = payload;
    },
    setCart(state, payload){
        state.cart = payload;
    },
    setMinQty(state,payload){
        state.minQty = payload;
    }
};

export default mutations;
